// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /contest/validate-config.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeContestValidateConfigBody,
  typeContestValidateConfigOutput200,
} from "../../sdk/contest/postContestValidateConfig";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildContestValidateConfigQueryKey(
  payload: typeContestValidateConfigBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`config:${JSON.stringify(payload.config)}`);
  if (typeof payload.name !== "undefined") {
    queryKeySegments.push(`name:${JSON.stringify(payload.name)}`);
  }
  return [
    "post:contest:contestValidateConfig",
    "svc:contest-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeContestValidateConfigOutput200,
    unknown,
    typeContestValidateConfigOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useContestValidateConfig(
  payload: typeContestValidateConfigBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildContestValidateConfigQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postContestValidateConfig(payload),
    ...resolvedOptions,
  });
}
